export class Address {
    constructor(
        public addressId?: number,
        public personId?: number,
        public addressTypeId?: number,
        public zipCode?: string,
        public addressName?: string,
        public number?: string,
        public complement?: string,
        public neighborhood?: string,
        public city?: string,
        public uf?: string
    ){

    }
}

export class AddressType{
    public addressTypeId: number;
    public description: string;
    public assignorLabel: string;
    public active: boolean;
}
